import lightPalette from './light-palette';
import typography from './typography';
import spacing from './spacing';

export default {
  palette: { light: lightPalette },
  typography,
  spacing,
};
